import React from "react";
import SamplePassportPopup from "./SamplePassportPopup";

export interface ISamplePassportMobileViewProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}

// Mobile uses the same centred modal (single column, internal scroll) as
// desktop instead of a bottom sheet.
const SamplePassportMobileViewProps = (props: ISamplePassportMobileViewProps) => (
  <SamplePassportPopup showPopup={props.showPopup} setShowPopup={props.setShowPopup} />
);
export default SamplePassportMobileViewProps;
